export default __webpack_public_path__ + "img/testimonial-icon.7bfbe262.svg";